'use strict';

/**
 * newPdp/stores/ItemStore uses the helpers in this file to calculate
 * the details that will appear on the pdp based on the
 * item's vertical. Copy for the details titles is not determined in
 * these helpers. These methods return only the information that will
 * appear under a detail's title.
 */

const creatorHelpers = require('./detailsCreators');
const originHelpers = require('./detailsOrigins');
const periodHelpers = require('./detailsPeriods');
const styleHelpers = require('./detailsStyles');
const materialHelpers = require('./detailsMaterials');
const conditionHelpers = require('./detailsCondition');
const measurementHelpers = require('./detailsMeasurements');
const miscellaneousHelpers = require('./detailsMiscellaneous');
const verticals = require('dibs-vertical-helpers');


// Helpers for calculating the pdp details that appear
// for items in every vertical
const sharedGetters = {
    condition: conditionHelpers.getCondition,
    wear: conditionHelpers.getWear,
    dimensions: measurementHelpers.getDimensions,
    diameter: measurementHelpers.getDiameter,
    length: measurementHelpers.getLength,
    weight: measurementHelpers.getWeight,
    dealerLocation: miscellaneousHelpers.getDealerLocation,
    dealerReference: miscellaneousHelpers.getDealerReference,
    quantity: miscellaneousHelpers.getQuantity,
    referenceNumber: miscellaneousHelpers.getReferenceNumber,
    itemLocation: miscellaneousHelpers.getItemLocation,
    period: periodHelpers.getPeriod
};

// Helpers for calculating the pdp details that appear
// for items in the furniture vertical
const furnitureGetters = {
    creator: creatorHelpers.getCreatorsFurniture,
    productionType: miscellaneousHelpers.getProductionType,
    leadTime: miscellaneousHelpers.getLeadTime,
    periodOf: styleHelpers.getPeriodOf,
    styleOf: styleHelpers.getStyleOf,
    placeOfOrigin: originHelpers.getPlaceOfOriginFurniture,
    dateOfManufacture: miscellaneousHelpers.getDateOfManufacture,
    materialsAndTechniques: materialHelpers.getMaterialsAndTechniques,
    seatHeight: measurementHelpers.getSeatHeight
};

// Helpers for calculating the pdp details that appear
// for items in the jewelry vertical
const jewelryGetters = {
    creator: creatorHelpers.getCreatorJewelry,
    periodOf: styleHelpers.getPeriodOf,
    placeOfOrigin: originHelpers.getPlaceOfOrigin,
    dateOfManufacture: miscellaneousHelpers.getDateOfManufacture,
    metal: materialHelpers.getMetals,
    stone: materialHelpers.getStones
};

// Helpers for calculating the pdp details that appear
// for items in the art vertical
const artGetters = {
    creator: creatorHelpers.getCreatorArt,
    placeOfOrigin: originHelpers.getPlaceOfOrigin,
    dateOfManufacture: miscellaneousHelpers.getDateOfManufacture,
    medium: materialHelpers.getMediums,
    styleOf: styleHelpers.getStyleOf,
    versions: miscellaneousHelpers.getVersions
};

// Helpers for calculating the pdp details that appear
// for items in the fashion vertical
const fashionGetters = {
    creator: creatorHelpers.getCreatorFashion,
    brand: creatorHelpers.getManufacturer,
    styleOf: styleHelpers.getStyleOfLegacy,
    placeOfOrigin: originHelpers.getPlaceOfOrigin,
    materialNotes: materialHelpers.getMaterialsNotes,
    markedSize: measurementHelpers.getMarkedSize,
    bust: measurementHelpers.getBust,
    waist: measurementHelpers.getWaist,
    hip: measurementHelpers.getHip,
    shoulderToHem: measurementHelpers.getShoulderHem,
    inseam: measurementHelpers.getInseam
};

module.exports = {
    /**
     * Grabs an object containing the helpers used to calculate the
     * pdp details for the item's vertical, merges that with the object
     * containing the helpers that appear in every vertical, and returns
     * the combined object.
     *
     * @param {string} vertical  - the item's vertical
     * @returns {Object}         - keys are the type of detail, ie: 'creator'
     *                             values are a method used to calculate that detail
     */
    getHelpers: function (vertical) {
        let helpers;

        switch (vertical) {
            case verticals.VERTICAL_FURNITURE:
                helpers = furnitureGetters;
                break;
            case verticals.VERTICAL_JEWELRY:
                helpers = jewelryGetters;
                break;
            case verticals.VERTICAL_ART:
                helpers = artGetters;
                break;
            case verticals.VERTICAL_FASHION:
                helpers = fashionGetters;
                break;
        }

        return Object.assign({}, helpers, sharedGetters);
    }
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/helpers/detailsHelpers.es.js